import { render, staticRenderFns } from "./Acessorio.vue?vue&type=template&id=43cd578a&"
import script from "./Acessorio.vue?vue&type=script&lang=js&"
export * from "./Acessorio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports